export const EXPERIMENTS = {
  USE_DISCOUNT_PRICES: 'useDiscountOnOrderingPage',
  WDS_SETTINGS_PANEL_ENABLED: 'specs.restaurants.menusSettingsWds',
  ITEM_FEATURED_TYPE: 'menusItemFeaturedType',
  RESTAURANTS_MENU_PAYWALL: 'restaurantsMenuPaywall',
};
